import React, { Component } from 'react';
import {Grid,Typography,Paper} from '@material-ui/core';

export default class PageNotFound extends Component {

    componentDidMount(){
    }
  render() {
    return (
        <React.Fragment>
            <Grid xs={12} sm={6} style={{margin:'0 auto',}}>
            <Paper  style={{padding:'10vmin', marginTop:'5vmin'}}>
            <Typography variant="h2 " gutterBottom>
        We Are Sorry
        </Typography>
        <Typography variant="h5" gutterBottom>
       You might enter the wrong URL.
        </Typography>
        <Typography variant="h5" gutterBottom>
        Please enter the right URL.
        </Typography>
        </Paper>
         </Grid>
  </React.Fragment>
    );
  }

} 


